/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import ftmQuestions from 'images/coin-pages/questions/ftm.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const ftmPage: ICoinPageData = {
  title: 'coin_440',
  description: 'coin_441',
  // description:
  //   'Borrow Fantom against Stablecoins.' +
  //   ` Get a stablecoin loan using your FTM coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Fantom (FTM)' }) }} />
  ),
  questionsBlock: {
    image: ftmQuestions,
    questions: [
      {
        title: 'coin_442',
        answer: 'coin_443',
      },
      {
        title: 'coin_444',
        answer: 'coin_445',
      },
      {
        title: 'coin_446',
        answer: 'coin_447',
      },
      {
        title: 'coin_448',
        answer: 'coin_449',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Fantom (FTM)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_450',
        text: ['coin_452'],
      },
      {
        title: 'coin_451',
        text: ['coin_453', 'coin_454', 'coin_455'],
      },
    ],
    ...commonLearnMoreData('Fantom (FTM)'),
  },
}
